import { getErrorMsgAndCode, validateInput } from "./FrontendHelpers";
import api from "./axios";

const checkInput = (ID, Name) => {
  return validateInput([
    {
      Name: "ID",
      Value: ID,
      Type: "clientID",
      MaxLengthType: "id",
      MinLength: 1,
    },
    {
      Name: "Name",
      Value: Name,
      Type: "string",
      MinLength: 1,
      MaxLengthType: "name",
    },
  ]);
};

export async function GetClients() {
  try {
    const response = await api.get("/getClients");
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CreateClient(
  props //Used here because there are a lot of properties unlike other create functions
) {
  try {
    const validationError = checkInput(props.ClientID, props.Name);
    if (validationError.errCode !== 0) return [null, validationError];

    const data = Object.entries(props).reduce((acc, [key, value]) => {
      acc[key] =
        value === undefined || value === null || value === "" ? "/" : value;
      return acc;
    }, {});

    const response = await api.post("/createClient", data);

    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function EditClient(
  props, //Look at comment in CreateClient
  CurrentID
) {
  try {
    const validationError = checkInput(props.ID, props.Name);
    if (validationError.errCode !== 0) return [null, validationError];

    const data = Object.entries(props).reduce((acc, [key, value]) => {
      acc[key] =
        value === undefined || value === null || value === "" ? "/" : value;
      return acc;
    }, {});
    data["CurrentID"] = CurrentID;

    const response = await api.post("/editClient", data);

    const result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetColumnValues(column = "Type") {
  try {
    const data = { Column: column };

    const response = await api.post("/getClientFieldValues", data);
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetClientData(argument, bywhat = "ClientID") {
  try {
    const data = { Argument: argument, byWhat: bywhat };
    const response = await api.post("/getClientInfo", data);
    const result = response.data;

    return [result[0], null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetNextClientID() {
  try {
    const response = await api.get("/getNextClientID");
    const result = response.data;
    return [result.nextID, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);

    return [null, errorObj];
  }
}

export async function DeleteClient(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/deleteClient", data);
    const result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CheckForClient(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/checkForClient", data);

    const result = response.data;
    if (result?.exists) {
      return [result.exists, null];
    }

    return [false, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
